module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "create-baseline-button"
  }, [_c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.create-baseline-modal",
      modifiers: {
        "create-baseline-modal": true
      }
    }],
    attrs: {
      "variant": "primary"
    }
  }, [_vm._v("\n      Create baseline\n    ")])], 1), _vm._v(" "), _c('create-baseline-modal'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('section', {
    staticClass: "col-md-3"
  }, [_c('baseline-list', {
    attrs: {
      "baselines": _vm.baselines
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [(_vm.currentBaseline) ? _c('baseline-detail', {
    attrs: {
      "baseline-prop": _vm.currentBaseline
    }
  }) : _vm._e()], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2385b758"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BaselineExplorer.vue
// module id = 1001
// module chunks = 1